import React from 'react'
import PropTypes from 'prop-types'

import MyImage from '@shared/components/myImage'
import noImage from 'assets/images/placeholder/person-placeholder.jpg'
import TwitterIcon from 'assets/images/icon/twitter-color-icon.svg'

function ReelTwitter({ styles, data }) {
  return (
    <div className="position-relative mw-100 h-100 pt-5 px-3 pb-3">
      <div className={`${styles.reeltwitter}`}>
        <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
          <div className={`${styles.overlayTitle} mb-0 d-flex align-items-center`}>
            <MyImage
              className={`${styles.userImage} rounded-circle`}
              src={data?.oReelAuthor?.oProfileImage?.sUrl || noImage}
              height={30}
              width={30}
              errorSrc={noImage}
              alt={data?.oReelAuthor?.oProfileImage?.sText || ''}
            />
            <h6 className="m-0">{data?.oReelAuthor?.sAccountName}</h6>
          </div>
          <a href={data?.sLink} className={`${styles.twitterBtn}`} target="_blank" rel="nofollow noreferrer">
            <MyImage src={TwitterIcon} alt="X" />
          </a>
        </div>
        <div className={`${styles.twitterContent}`}>
          <p>{data?.sTitle}</p>
        </div>
        {data?.aMedia?.length > 0 && (
          <div className={`${styles.twitterImagesGrid} ${styles[`images-${data?.aMedia?.length}`]} mt-3`}>
            {data?.aMedia.map((img, i) => {
              if (img?.eMediaType === 'i') {
                return (
                  <MyImage
                    key={`${img?.eMediaType}-${i}`}
                    src={img?.sImageURL}
                    className={`${styles.twitterImage}`}
                    alt="Image"
                    width={350}
                    height={350}
                  />
                )
              } else {
                return null
              }
            })}
          </div>
        )}
        {/* <div className={`${styles.twitterVideo} d-none`}>
          <video width="100%" height="100%" autoPlay loop muted playsInline>
            <source type="video/mp4" src="https://www.w3schools.com/html/mov_bbb.mp4" />
          </video>
        </div> */}
      </div>
    </div>
  )
}

ReelTwitter.propTypes = {
  styles: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired
}

export default ReelTwitter
